import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SOConsolidationEventModel } from "../../../../../../models/aggregates/so-consolidation/index";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
} from "../../shared";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SOConsolidationEventProcessorService extends BaseApiTemplateService<SOConsolidationEventModel> {
  private readonly baseEndpoint = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}sales-order-to-sales-invoice-consolidation/event-hdrs`;
  private readonly processorEndpoint = `${this.baseEndpoint}/processors/backoffice-ep`;
  private readonly deleteEndpoint = `${this.baseEndpoint}/recurring-delete/backoffice-ep`;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = `${Core2Config.DOMAIN_URL}${this.baseEndpoint}`;
    this.httpClient = http;
  }

  createEvent(
    eventData: any,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    const apiUrl = visa.api_domain_url
      ? `${visa.api_domain_url}${this.processorEndpoint}`
      : `${this.apiUrl}/processors/backoffice-ep`;

    return this.httpClient.post<ApiResponseModel<any>>(
      apiUrl,
      eventData,
      this.getHttpHeader(visa)
    );
  }

  updateEvent(
    eventData: any,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    const apiUrl = visa.api_domain_url
      ? `${visa.api_domain_url}${this.processorEndpoint}`
      : `${this.apiUrl}/processors/backoffice-ep`;

    return this.httpClient.put<ApiResponseModel<any>>(
      apiUrl,
      eventData,
      this.getHttpHeader(visa)
    );
  }

  deleteEvent(
    guid: string,
    deleteType: any,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    const apiUrl = visa.api_domain_url
      ? `${visa.api_domain_url}${this.deleteEndpoint}/${guid}`
      : `${this.apiUrl}/recurring-delete/backoffice-ep/${guid}`;

    const params = { recurring_delete_type: deleteType };

    return this.httpClient.delete<ApiResponseModel<any>>(apiUrl, {
      ...this.getHttpHeader(visa),
      params,
    });
  }
}
